var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.6511L17.0156 15.6667V16.6511H0.984375V15.6667L3 13.6511V8.68231C3 7.11981 3.39062 5.76044 4.17188 4.60419C4.98438 3.44794 6.09375 2.69794 7.5 2.35419V1.65106C7.5 1.24481 7.64062 0.901062 7.92188 0.619812C8.20312 0.307312 8.5625 0.151062 9 0.151062C9.4375 0.151062 9.79688 0.307312 10.0781 0.619812C10.3594 0.901062 10.5 1.24481 10.5 1.65106V2.35419C11.9062 2.69794 13 3.44794 13.7812 4.60419C14.5938 5.76044 15 7.11981 15 8.68231V13.6511ZM9 19.6511C8.4375 19.6511 7.95312 19.4636 7.54688 19.0886C7.17188 18.7136 6.98438 18.2448 6.98438 17.6823H11.0156C11.0156 18.2136 10.8125 18.6823 10.4062 19.0886C10 19.4636 9.53125 19.6511 9 19.6511Z",
    fill: "#7E4698"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBell);
export default __webpack_public_path__ + "static/media/ic_bell.ee3f1086d005dcc0f046c96f4860254e.svg";
export { ForwardRef as ReactComponent };